import {
  GiftVo,
  IGBannerVo,
  SaveLifeControllerService,
} from '@/__generated__/FrontApi';
import Process01 from '@/assets/img/icons/icon_life_saving_gift_process_01@2x.png';
import Process02 from '@/assets/img/icons/icon_life_saving_gift_process_02@2x.png';
import Process03 from '@/assets/img/icons/icon_life_saving_gift_process_03@2x.png';
import Process04 from '@/assets/img/icons/icon_life_saving_gift_process_04@2x.png';
import Banner02 from '@/assets/img/ig_banner_02.png';
import Banner03 from '@/assets/img/ig_banner_03.png';
import Banner04 from '@/assets/img/ig_banner_04.png';
import Banner05 from '@/assets/img/ig_banner_05.png';
import Banner06 from '@/assets/img/ig_banner_06.png';
import Banner07 from '@/assets/img/ig_banner_07.png';
import Banner08 from '@/assets/img/ig_banner_08.png';
import Banner09 from '@/assets/img/ig_banner_09.png';
import Banner1 from '@/assets/img/img_life_saving_gift_banner_01.png';
import Banner3 from '@/assets/img/img_life_saving_gift_banner_2023.png';
import BannerM3 from '@/assets/img/img_life_saving_gift_banner_2023_m.png';
import Package01 from '@/assets/img/img_package_01@2x.png';
import Package02 from '@/assets/img/img_package_02@2x.png';
import Package03 from '@/assets/img/img_package_03@2x.png';
import AccordionComponent, { AccordionItem } from '@/components/Accordion';
import Button from '@/components/Button';
import Container from '@/components/Container';
import Image from '@/components/Image';
import ImageIcon from '@/components/ImageIcon';
import LinkSafe from '@/components/LinkSafe';
import PageComponent from '@/components/PageComponent';
import { DataItem, ProcessListSeo } from '@/components/ProcessList';
import Section from '@/components/Section';
import SectionHeader from '@/components/SectionHeader';
import TabPanel, {
  CategoryData,
  ProductData,
  TabData,
} from '@/components/SubMainTab';
import CartModule from '@/components/Support/CartModule';
import { Tit } from '@/components/Titles';
import { breakpoint } from '@/helpers/BreakpointHelper';
import GtmHelper, { SelectItemDefaultIGData } from '@/helpers/GtmHelper';
import { SUPPORT_TERM_ONCE } from '@/helpers/SupportHelper';
import LayoutWithTitle from '@/layouts/LayoutWithTitle';
import { navigate, PageProps } from 'gatsby';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { GtmButtonDonate } from '@/components/Button.gtm';

const tab: TabData[] = [
  {
    // 스페셜 패키지
    id: `04100`,
    subject: `특별한 기부선물로 어린이의 내일을 응원해 주세요!`,
    content: `재난과 분쟁 속 어린이의 생명을 구하는 특별한 구호물품기부로 전 세계 어린이들에게 따뜻한 희망을 선물해 주세요.`,
    image: Banner08,
  },
  {
    // 교육
    id: `04110`,
    subject: `모든 어린이가 읽고 쓰고 셈할 수 있게 도와주세요!`,
    content: `성차별, 조혼, 가사노동, 위험한 등굣길, 부족한 학교 시설과 열악한 환경 등으로 초등학교에 다니지 못하는 취학연령 어린이가 5천 7백만 명입니다.`,
    image: Banner1,
  },
  {
    // 영양
    id: `04120`,
    subject: `어린이들에게 건강한 미래를 선물하세요!`,
    content: `해마다 520만 명이 다섯 번째 생일을 맞지 못하고 소중한 생명을 잃습니다.`,
    image: Banner02,
  },
  {
    // 예방접종
    id: 2,
    subject: `예방 가능한 질병으로부터 아이들을 지켜주세요!`,
    content: `매년 사망하는 5세 미만 어린이 690만 명 중 64%는 폐렴, 설사병, 홍역, 말라리아, HIV 등 예방 가능한 질병으로 목숨을 잃습니다. 2,240만 명은 꼭 필요한 기본 예방접종조차 받지 못합니다.`,
    image: Banner03,
  },
  {
    // 말라리아
    id: `04190`,
    subject: `모기로부터 어린이들의 생명을 구해주세요!`,
    content: `매년 2억명 이상이 말라리아에 감염됩니다. 말라리아로 사망하는 66만 명 가운데 91%는 5세 미만 어린이입니다. 1분마다 1명이 목숨을 잃습니다.`,
    image: Banner04,
  },
  {
    // 건강
    id: `04130`,
    subject: `모든 어린이가 건강하고 튼튼하게 자라도록 도와주세요!`,
    content: `5세 미만 아동의 23%가 폐렴과 설사병과 같은 충분히 치료 가능한 질병으로 목숨을 잃습니다. 에이즈 감염자 330만 명이 15세 미만 어린이이며, 에이즈 고아도 1,730만 명에 이릅니다.`,
    image: Banner05,
  },
  {
    // 모성건강
    id: `04210`,
    subject: `엄마와 아기의 건강과 행복을 지켜주세요!`,
    content: `전 세계 어린이 1,000명 중 37명은 5살 생일을 넘기지 못하고 목숨을 잃습니다. 그 중 47%는 생후 첫 달에 사망하는데, 주산기 질식이나 감염이 대부분의 경우를 차지하며, 많은 경우 미숙아로 태어나기 때문입니다.`,
    image: Banner09,
  },
  {
    // 깨끗한 식수
    id: `04140`,
    subject: `생명을 살리는 깨끗하고 안전한 물이 필요해요!`,
    content: `안전한 식수를 사용하지 못하는 인구 7억 4천 800만 명, 오염된 물로 인한 설사병으로 매일 어린이 800명이 생명을 잃습니다.`,
    image: Banner06,
  },
  {
    // 보호
    id: `04150`,
    subject: `아주 먼 곳까지 따뜻한 손길이 닿을 수 있도록 도와주세요!`,
    content: `개발도상국에는 비포장도로가 많아 외딴 지역 어린이들은 필요한 지원을 받지 못합니다.
    전쟁이나 자연재해 등의 긴급상황이나 기반시설 미비로 어린이들이 보호받을 수 있는 공간도 부족합니다.`,
    image: Banner07,
  },
];

const processes: DataItem[] = [
  {
    id: 1,
    title: `후원`,
    img: Process01,
    desc: [{ dec: `선물하고 싶은 후원물품 선택` }],
  },
  {
    id: 2,
    title: `접수`,
    img: Process02,
    desc: [
      {
        dec: `코펜하겐 물류센터에
      선택된 품목 접수`,
      },
    ],
  },
  {
    id: 3,
    title: `요청`,
    img: Process03,
    desc: [
      {
        dec: `개발도상국 대표사무소에서
      필요한 구호물품 요청`,
      },
    ],
  },
  {
    id: 3,
    title: `전달`,
    img: Process04,
    desc: [
      {
        dec: `긴급한 순서대로
      어린이들에게 전달`,
      },
    ],
  },
];
const CartButton = styled.div`
  width: 180px;
  position: absolute;
  right: 0;
  top: 66px;
  ${breakpoint(800)} {
    position: static;
    width: 100%;
    margin-top: 72px;
  }
`;

const BannerImage = styled.div`
  a {
    display: block;
    width: 100%;
    img {
      max-width: 100%;
    }
  }
`;

const PackageContainer = styled.div`
  ${breakpoint(`tablet`)} {
    overflow-x: auto;
    margin: 0 -20px;
    padding: 0 20px;
  }
`;
const PackageList = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 -64px;
  padding: 0 49px;

  ${breakpoint(1160)} {
    margin: 0 -5.52vw;
    padding: 0 3.97vw;
  }

  ${breakpoint(`tablet`)} {
    display: inline-flex;
  }

  article {
    width: 33.33%;
    padding: 0 64px;
    display: flex;
    flex-direction: column;

    ${breakpoint(1160)} {
      padding: 0 5.52vw;
    }S

    ${breakpoint(`tablet`)} {
      width: 234px;
      padding: 0;
      margin-right: 24px;

      &:last-child {
        margin-right: 0;
      }
    }

    .img-box {
      width: 100%;
      padding-top: 83.53%;
    }
  }
`;

const TextWrap = styled.div`
  margin-bottom: auto;
  padding: 24px;

  ${breakpoint(1160)} {
    padding: 24px 0;
  }

  h3 {
    margin-bottom: 16px;
    line-height: 1.58;
    letter-spacing: -1.2px;
  }

  .price {
    margin-bottom: 16px;
    line-height: 1.6;
    letter-spacing: -1.2px;
  }

  ul {
    width: 100%;
    padding-top: 16px;
    border-top: solid 1px #e5e6e8;

    li {
      line-height: 1.2;
      margin-bottom: 13px;
      letter-spacing: -0.8px;
    }
  }
`;

const QnaNavigationButton = styled.div`
  padding: 24px 48px 24px 24px;
  cursor: pointer;
  font-weight: bold;
  font-size: 20px;
  position: relative;
  ${breakpoint(`mobile`)} {
    font-size: 16px;
    padding: 20px 40px 20px 0;
  }
`;
const QnaAccordionBody = styled.div`
  padding: 24px;
  font-size: 16px;
  color: #2d2926;
  line-height: 1.7;
  ${breakpoint(`mobile`)} {
    font-size: 14px;
    padding: 16px 0;
  }
  ul {
    margin-top: 12px;
    li {
      position: relative;
      padding-left: 16px;
      margin-bottom: 8px;
      &::before {
        content: '';
        display: block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #2d2926;
        position: absolute;
        left: 0;
        top: 10px;
      }
    }
  }
`;

const LifeSavingGift: React.FC<PageProps> = ({ location }) => {
  const [isCartModalOpen, setIsCartModalOpen] = useState(false);

  const [categories, setCategories] = useState<CategoryData[]>([]);
  const [products, setProducts] = useState<ProductData[]>([]);
  const [banner, setBanner] = useState<IGBannerVo>();

  // 카테고리 로드
  const loadCategories = useCallback(async () => {
    try {
      const {
        data: giftCategory,
      } = await SaveLifeControllerService.getCategoryCodeListUsingGet();
      setCategories(
        giftCategory.map((category: GiftVo) => ({
          id: category.categoryCode,
          categoryCode: category.categoryCode,
          categoryCodeName: category.categoryCodeName,
        })),
      );
    } catch (e) {
      console.error(e);
    }
  }, []);

  // 생명을 구하는 선물 로드
  const loadProducts = useCallback(async () => {
    try {
      const {
        data: giftProduct,
      } = await SaveLifeControllerService.getSaveLifeListUsingGet();
      setProducts(
        giftProduct.map((product: GiftVo) => ({
          id: product.productCode,
          categoryCode: product.categoryCode,
          imgPath: product.imgProductAttImgNo1_420,
          productCode: product.productCode,
          productName: product.productName,
          productNameEn: product.productNameEn,
          productPrice: product.productPrice,
          categoryCodeName: product.categoryCodeName,
        })),
      );
    } catch (e) {
      console.error(e);
    }
  }, []);

  // 배너 로드
  const loadBanner = useCallback(async () => {
    try {
      const {
        data: giftBanner,
      } = await SaveLifeControllerService.getIgMainBannerUsingGet();
      setBanner(giftBanner);
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    loadCategories();
    loadProducts();
    loadBanner();
  }, [loadBanner, loadCategories, loadProducts]);

  // 패키지 상품
  const packageNumber = [`0001007`, `0001014`, `0001009`];
  const filterPack = products?.filter((code: ProductData) =>
    packageNumber.includes(String(code.productCode)),
  );
  // 가격 낮은순 재정렬
  const filterSort = filterPack.sort((a, b) => {
    if (a.productPrice > b.productPrice) return 1;
    if (a.productPrice === b.productPrice) return 0;
    if (a.productPrice < b.productPrice) return -1;
  });

  return (
    <LayoutWithTitle
      location={location}
      title="생명을 구하는 선물"
      description="for every child, inspired gifts"
    >
      <Section className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <div className="flex">
              <h2>
                <Tit size="s1">
                  <PageComponent id="title1">
                    지구촌 어린이들의
                    <br />
                    생명을 살리는 구호물품기부
                  </PageComponent>
                </Tit>
              </h2>
              <div>
                <Button
                  color="blue"
                  width={160}
                  className="small-hide"
                  onClick={() => setIsCartModalOpen(true)}
                >
                  <ImageIcon name="cart" /> 장바구니
                </Button>
              </div>
            </div>
            <p>
              <PageComponent id="content1">
                아동 기부를 통해 모든 어린이가 건강하게 자라고,
                <br />
                학교에 다니며, 깨끗한 물을 마실 수 있습니다.
                <br />
                구호물품기부로 특별한 선물을 전해보세요
              </PageComponent>
            </p>
            <Button
              color="blue"
              full
              className="small-show"
              onClick={() => setIsCartModalOpen(true)}
            >
              <ImageIcon name="cart" /> 장바구니
            </Button>
          </SectionHeader>
          {products.length > 0 && (
            <div className="activity-tabpanel">
              <TabPanel
                products={products}
                tabs={tab}
                categories={categories}
                SelectItemDefaultData={SelectItemDefaultIGData}
              />
            </div>
          )}
        </Container>
      </Section>

      <Section
        css={`
          padding: 60px 0;
          ${breakpoint(`mobile`)} {
            padding: 40px 0;
          }
        `}
      >
        <Container>
          <AccordionComponent initialKey="ig-qna-1">
            <AccordionItem
              toggleKey="ig-qna-1"
              renderToggle={(onClick) => (
                <QnaNavigationButton
                  onClick={onClick}
                  className="accordion-opener"
                >
                  <h3>
                    Q. 유니세프 구호 물품 기부로 어떤 문제를 해결할 수 있나요?
                  </h3>
                </QnaNavigationButton>
              )}
            >
              <QnaAccordionBody>
                <p>
                  구호 물품 기부는 결식아동, 난치병 환아, 긴급 구호가 필요한
                  어린이 등 다양한 취약 계층의 구체적인 문제를 해결합니다.
                  유니세프의 기부 물품 카테고리를 통해 교육, 영양, 예방접종, 보호
                  등 필요한 분야를 직접 선택할 수 있으며, 가장 도움이 필요한
                  아동에게 순서대로 전달됩니다.
                </p>
                <ul>
                  <li>
                    영양 결핍: 개발도상국 아동의 영양실조 문제 개선 및 성장 발달
                    지원
                  </li>
                  <li>
                    교육 격차: 학용품, 교재 등 아동 지원 물품 제공으로 배움의
                    기회가 없는 어린이에게 교육 접근성 확대
                  </li>
                  <li>
                    긴급 상황 대응: 자연재해나 분쟁 지역의 아동에게 어린이 구호
                    패키지를 통한 신속한 생필품 지원
                  </li>
                </ul>
              </QnaAccordionBody>
            </AccordionItem>
          </AccordionComponent>
        </Container>
      </Section>

      <Section className="by-sub-main-layout" backgroundColor="#f8f9fa">
        <Container>
          <SectionHeader>
            <h2>
              <Tit size="s1">아동 기부 로 어린이에게 선물할 수도 있어요</Tit>
            </h2>
            <p className="head-dec">
              슈퍼히어로팩, 건강쑥쑥 어린이팩, 어린이 긴급구호팩 중에서 선택하여 기부할 수 있으며,<br />
              각 패키지는 소외된 아동에게 꼭 필요한 기부 물품으로 구성되어 있습니다.<br />
              아동 기부 물품은 투명하게 전달되며, 어린이 구호 패키지를 통해 실질적인 도움을 제공할 수 있습니다.
            </p>
          </SectionHeader>
          <PackageContainer>
            <PackageList>
              {filterSort.map((row, index) => (
                <article key={row.id}>
                  {index === 0 && (
                    <div
                      className="img-box"
                      css={`
                        background-image: url(${Package01});
                      `}
                    />
                  )}
                  {index === 1 && (
                    <div
                      className="img-box"
                      css={`
                        background-image: url(${Package02});
                      `}
                    />
                  )}
                  {index === 2 && (
                    <div
                      className="img-box"
                      css={`
                        background-image: url(${Package03});
                      `}
                    />
                  )}
                  <TextWrap>
                    <h3>
                      <Tit size="s3">{row.productName}</Tit>
                    </h3>
                    <Tit size="s4" className="price">
                      {row.productPrice.toLocaleString()}원
                    </Tit>

                    <ul>
                      {row.productCode === `0001007` && (
                        <>
                          <li>소아마비백신 150회분</li>
                          <li>홍역백신 50회분</li>
                          <li>모기장 10개</li>
                        </>
                      )}
                      {row.productCode === `0001014` && (
                        <>
                          <li>영양실조치료식 100봉</li>
                          <li>영양실조치료식우유 8캔</li>
                          <li>복합미량영양소 660봉</li>
                        </>
                      )}
                      {row.productCode === `0001009` && (
                        <>
                          <li>고영양 비스킷 100개</li>
                          <li>긴급구호 비상식량 216개</li>
                          <li>응급처치키트 1개</li>
                          <li>식수정화제 333정</li>
                        </>
                      )}
                    </ul>
                  </TextWrap>
                  <GtmButtonDonate
                    type="button"
                    text="후원하기"
                    color="blue"
                    size="md"
                    shape="square"
                    full
                    goto={`/involve/individual/ig/${row.productCode}`}
                    gtmInfo={{
                      ...SelectItemDefaultIGData,
                      itemId: row.productCode.toString(),
                      itemName: row.productName,
                      itemCategory: SUPPORT_TERM_ONCE,
                      itemListName: row.categoryCodeName,
                      itemBrand: '생명을 구하는 선물',
                    }}
                    onClickPreEvent={() => {
                      // TODO onClick before call gtm
                      // alert('click');
                    }}
                  />
                </article>
              ))}
            </PackageList>
          </PackageContainer>
        </Container>
      </Section>

      <Section className="by-sub-main-layout">
        <Container>
          <SectionHeader>
            <h2>
              <Tit size="s1">
                유니세프는 후원자님의 기부금으로<br />
                구호물품을 투명하게 전달합니다.
              </Tit>
            </h2>
            <p className="head-dec">
              선택하신 아동 기부 물품은 개발도상국 대표사무소의 요청에 따라<br />
              가장 도움이 시급한 어린이에게 우선적으로 어린이 구호 패키지를 전달합니다.<br />
              소액 기부로도 도움이 필요한 어린이에게 실질적인 변화를 만들 수 있으며,<br />
              모든 기부 물품은 각 단계마다 검증을 거쳐 아동 지원 프로그램에 투명하게 사용됩니다.
            </p>
          </SectionHeader>
          <ProcessListSeo itemData={processes} arrow />
        </Container>
      </Section>
      {
      banner && (
        <Section className="by-sub-main-layout">
          <Container>
            <SectionHeader>
              <h2>
                <Tit size="s1">캠페인</Tit>
              </h2>
            </SectionHeader>
            <BannerImage>
              {banner.bannerTargetUrl ? (
                <LinkSafe
                  to={banner.bannerTargetUrl}
                  target={banner.bannerTargetClick}
                >
                  <Image
                    pcSrc={banner.pcBannerAttNoTn}
                    mobileSrc={banner.mobileBannerAttNoTn}
                    alt="방패 선물하기 백신 한 방울, 생명을 구하는 방패 하나"
                  />
                </LinkSafe>
              ) : (
                <Image
                  pcSrc={banner.pcBannerAttNoTn}
                  mobileSrc={banner.mobileBannerAttNoTn}
                  alt="방패 선물하기 백신 한 방울, 생명을 구하는 방패 하나"
                />
              )}
            </BannerImage>
          </Container>
        </Section>
      )}
      {
      <Section className="by-sub-main-layout">
        <Container>
          <SectionHeader>
            <h2>
              <Tit size="s1">
                후원자님께서 보내주신
                <br />
                선물이 준 도움
              </Tit>
            </h2>
          </SectionHeader>
          <BannerImage>
            <a href="/igreport/2023/" target="_blank">
              <Image
                pcSrc={Banner3}
                mobileSrc={BannerM3}
                alt="2023년 생명을 구하는 선물 전달보고서"
              />
            </a>
          </BannerImage>
        </Container>
      </Section>
       }
      <Section
        css={`
          padding: 60px 0 120px 0;
          ${breakpoint(`mobile`)} {
            padding: 60px 0 80px 0;
          }
        `}
      >
        <Container>
          <AccordionComponent initialKey="ig-faq-1">
            <AccordionItem
              toggleKey="ig-faq-1"
              renderToggle={(onClick) => (
                <QnaNavigationButton
                  onClick={onClick}
                  className="accordion-opener"
                >
                  <h3>
                    Q. 경제적 여유가 없어도 소액 기부로 어린이를 도울 수 있나요?
                  </h3>
                </QnaNavigationButton>
              )}
            >
              <QnaAccordionBody>
                <p>
                  유니세프는 소액 기부도 모아서 큰 변화를 만들어냅니다. 소액이라도
                  매월 정기적으로 기부하면 영양실조 어린이에게 영양치료식을
                  제공하고, 깨끗한 식수를 위한 정수제를 보내며, 예방접종과 교육
                  물품을 지원할 수 있습니다. 80년간 축적된 전문성과 대량 구매
                  시스템으로 소액 기부라도 효율적으로 사용해 실질적인 생명 구호
                  효과를 냅니다.
                </p>
                <ul>
                  <li>
                    80년 현장 경험과 대량 구매 시스템으로 기부 효율성 극대화
                  </li>
                  <li>
                    190개국 정부 협력으로 같은 금액으로 더 많은 어린이 지원 가능
                  </li>
                  <li>지속적인 생명 구호 및 교육·보건·영양 사업 운영</li>
                </ul>
              </QnaAccordionBody>
            </AccordionItem>
            <AccordionItem
              toggleKey="ig-faq-2"
              renderToggle={(onClick) => (
                <QnaNavigationButton
                  onClick={onClick}
                  className="accordion-opener"
                >
                  <h3>
                    Q. 긴급 재난 상황에서 아동기부가 어떻게 도움이 되나요?
                  </h3>
                </QnaNavigationButton>
              )}
            >
              <QnaAccordionBody>
                <p>
                  유니세프는 긴급 재난 상황에서 신속하게 대응하는 글로벌 네트워크를
                  갖추고 있습니다. 아동을 위한 기부는 즉각적인 긴급구호 물품(식수,
                  의약품, 담요, 임시 거처) 제공과 장기적인 아동 보호 시스템 구축에
                  사용되며, 80년 현장 경험을 바탕으로 재난 상황의 어린이를 가장
                  효과적으로 지원합니다.
                </p>
                <ul>
                  <li>
                    재난 발생 후 24~72시간 내 긴급구호 물품 전달 시스템 가동
                  </li>
                  <li>
                    전 세계 190개국 현장 사무소 및 정부 협력 채널 보유
                  </li>
                  <li>
                    대량 구매 시스템으로 긴급구호 물품 비용 절감 및 신속 조달
                  </li>
                </ul>
              </QnaAccordionBody>
            </AccordionItem>
            <AccordionItem
              toggleKey="ig-faq-3"
              renderToggle={(onClick) => (
                <QnaNavigationButton
                  onClick={onClick}
                  className="accordion-opener"
                >
                  <h3>
                    Q. 긴급구호 아동에게 기부하면 실제로 어떤 구호물품이
                    전달되나요?
                  </h3>
                </QnaNavigationButton>
              )}
            >
              <QnaAccordionBody>
                <p>
                  기부금은 긴급구호 프로세스를 통해 즉시 생명을 지키는
                  구호물품으로 전환됩니다. 1차 긴급구호 단계에서는 식수, 의약품,
                  담요 등 생명 유지에 필수적인 물품이 위급한 순서대로 전달되고, 2차
                  지원 단계에서는 영양식, 위생키트, 의료용품 등 장기 지원 물품이
                  공급됩니다. 모든 구호물품 전달 과정은 현지 정부 및 단체와의
                  협력을 통해 투명하게 관리됩니다.
                </p>
                <ul>
                  <li>
                    재난 발생 후 24~72시간 내 1차
                    긴급구호물품(식수·의약품·담요) 전달
                  </li>
                  <li>
                    2차 지원에서 영양식·위생키트·의료용품 등 장기 구호물품 공급
                  </li>
                  <li>
                    현지 정부 협력 및 3단계 감사 시스템으로 투명한 전달 관리
                  </li>
                </ul>
              </QnaAccordionBody>
            </AccordionItem>
          </AccordionComponent>
        </Container>
      </Section>
      {isCartModalOpen && (
        <CartModule isOpen onRequestClose={() => setIsCartModalOpen(false)} />
      )}
    </LayoutWithTitle>
  );
};

export default LifeSavingGift;
